import { Content } from '@prismicio/client';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import Image from 'next/image';

/**
 * Props for `HeadlineCenteredIllustration`.
 */
export type HeadlineCenteredIllustrationProps =
  SliceComponentProps<Content.HeadlineCenteredIllustrationSlice>;

/**
 * Component for "HeadlineCenteredIllustration" Slices.
 */
const HeadlineCenteredIllustration = ({
  slice,
}: HeadlineCenteredIllustrationProps): JSX.Element => {
  if (slice.variation !== 'default') {
    return (
      <section
        data-slice-type={slice.slice_type}
        data-slice-variation={slice.variation}
        className="relative text-center"
      >
        <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center gap-12">
          <div className="max-w-4xl flex flex-col gap-2">
            {slice.primary.headline && (
              <PrismicRichText
                field={slice.primary.headline || []}
                components={{
                  heading2: ({ children }) => (
                    <h2 className="text-4xl md:text-5xl font-bold text-white">
                      {children}
                    </h2>
                  ),
                }}
              />
            )}
            {slice.primary.subheadline && (
              <PrismicRichText
                field={slice.primary.subheadline || []}
                components={{
                  heading2: ({ children }) => (
                    <h2
                      className="text-4xl md:text-5xl font-bold mb-8"
                      style={{ color: '#05F273' }}
                    >
                      {children}
                    </h2>
                  ),
                }}
              />
            )}
          </div>
          {/* TODO: Add Animated Scroll Here */}
        </div>
      </section>
    );
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="relative text-center bg-[#0F423A]"
    >
      <div className="container mx-auto py-6 md:py-0 px-4 md:px-6 flex flex-col items-center text-center gap-12">
        <div className="max-w-4xl flex flex-col gap-2">
          <PrismicRichText
            field={slice.primary.headline || []}
            components={{
              heading2: ({ children }) => (
                <h2 className="text-4xl md:text-5xl font-bold text-white font-inter">
                  {children}
                </h2>
              ),
            }}
          />
          <PrismicRichText
            field={slice.primary.subheadline || []}
            components={{
              heading2: ({ children }) => (
                <h2
                  className="text-4xl md:text-5xl font-bold mb-8 font-inter"
                  style={{ color: '#05F273' }}
                >
                  {children}
                </h2>
              ),
            }}
          />
        </div>

        {slice.primary.illustration && (
          <Image
            src={slice.primary.illustration.url!}
            alt={slice.primary.illustration.alt || 'Illustration'}
            width={slice.primary.illustration.dimensions?.width}
            height={slice.primary.illustration.dimensions?.height}
            className="mx-auto"
          />
        )}
      </div>
      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 w-full h-52 md:h-48 z-20 bg-gradient-to-b from-transparent to-[#0E1010] pointer-events-none" />
    </section>
  );
};

export default HeadlineCenteredIllustration;
